require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-my-l-pmusings.json") })
        }
      }, "path---insights-my-l-pmusings");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-my-l-pmusings!./.cache/json/insights-my-l-pmusings.json
// module id = 1129
// module chunks = 231608221292675